import { getParamValueFromUrl } from 'root/utils/URLParams/URLParams';
import { CookieMonster } from 'root/utils/cookies/cookieMonster';

function setCookieBasedOnKountaParam() {
    const isAU = window.location.hostname.includes('.com.au');
    if (!isAU) return;
    const kountaShareCodeParam = 'share_code';
    const kountaOfferCodeParam = 'offer_code';
    const cm = new CookieMonster();

    getParamValueFromUrl(kountaShareCodeParam) &&
        cm.setCookie(
            `_ls_${kountaShareCodeParam}`,
            getParamValueFromUrl(kountaShareCodeParam)
        );

    getParamValueFromUrl(kountaOfferCodeParam) &&
        cm.setCookie(
            `_ls_${kountaOfferCodeParam}`,
            getParamValueFromUrl(kountaOfferCodeParam)
        );
}

export { setCookieBasedOnKountaParam };
